<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vue-headful :title="$t('blocking-e-journal')" />

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <EditPopup :itemHandler="infiniteHandle" :getBlocksNone="getBlocksNone"/>

            <!-- ФИЛЬТРЫ -->
            <ListFilters ref="ListFilters" @closesidebar="toggleSidebar" :itemHandler="infiniteHandle" />
        </vs-sidebar>

        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- Поиск -->
            <div class="infinite_header flex border d-theme-dark-bg items-center">
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>

                <!-- Кнопка и выпадашка с датой для сохранения журнала -->
                 <transition name="slide" v-if="start_date_end_date">
                    <div v-show="journalEdited.length" v-if="start_date_end_date.close==false" class="w-full save_header">
                        <div class="flex lg:items-center lg:justify-between py-2 px-3">
                            <!-- Попап с выбором даты -->
                            <div>
                                <vs-dropdown class="mr-1" v-if="windowWidth > 992" ref="dateDrop" vs-custom-content vs-trigger-click>
                                    <a class="flex items-center" href.prevent>
                                        <vs-button
                                            icon-pack="feather"
                                            icon="icon-calendar"
                                            color="primary"
                                            type="border">
                                            {{selectedDate}}
                                        </vs-button>
                                    </a>
                                    <vs-dropdown-menu class="dropdown_datetime">
                                        <flat-pickr
                                            v-model="data_start_time"
                                            :config="config"/>
                                        <div class="flex justify-between">
                                            <vs-button
                                                @click="data_start_time = null"
                                                :disabled="data_start_time ? false : true"
                                                type="border"
                                                class="mt-3"
                                                size="small">
                                                {{$t('clear')}}
                                            </vs-button>
                                            <vs-button
                                                @click="closeDateDrop()"
                                                class="mt-3"
                                                size="small">
                                                {{$t('select')}}
                                            </vs-button>
                                        </div>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                                <flat-pickr
                                    v-else
                                    v-model="data_start_time"
                                    :config="mobileConfig"/>

                                <vs-dropdown v-if="windowWidth > 992" ref="dateDrop2" vs-custom-content vs-trigger-click>
                                    <a class="flex items-center" href.prevent>
                                        <vs-button
                                            icon-pack="feather"
                                            icon="icon-calendar"
                                            color="primary"
                                            type="border">
                                            {{selectedDate2}}
                                        </vs-button>
                                    </a>
                                    <vs-dropdown-menu class="dropdown_datetime">
                                        <flat-pickr
                                            v-model="data_end_time"
                                            :config="config"/>
                                        <div class="flex justify-between">
                                            <vs-button
                                                @click="data_end_time = null"
                                                :disabled="data_end_time ? false : true"
                                                type="border"
                                                class="mt-3"
                                                size="small">
                                                {{$t('clear')}}
                                            </vs-button>
                                            <vs-button
                                                @click="closeDateDrop2()"
                                                class="mt-3"
                                                size="small">
                                                {{$t('select')}}
                                            </vs-button>
                                        </div>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                                <flat-pickr
                                    v-else
                                    v-model="data_end_time"
                                    :config="mobileConfig"/>
                            </div>
                            <vs-button
                                icon-pack="feather"
                                class="save_btn"
                                @click="saveHandler()"
                                icon="icon-save">
                                    {{$t('save')}}
                            </vs-button>
                        </div>
                    </div>
                     <transition name="slide" v-if="start_date_end_date.close">
                         <div v-show="journalEdited.length" class="w-full save_header">
                             <div class="flex lg:items-center lg:justify-between py-2 px-3">
                                 <!-- Попап с выбором даты -->
                                 <vs-dropdown v-if="windowWidth > 992" ref="dateDrop" vs-custom-content vs-trigger-click>
                                     <a class="flex items-center" href.prevent>
                                         <vs-button
                                             icon-pack="feather"
                                             icon="icon-calendar"
                                             color="primary"
                                             type="border">
                                             {{selectedDate0}}
                                         </vs-button>
                                     </a>
                                     <vs-dropdown-menu class="dropdown_datetime">
                                         <flat-pickr
                                             v-model="date_time"
                                             :config="config0"/>
                                         <div class="flex justify-between">
                                             <vs-button
                                                 @click="date_time = null"
                                                 :disabled="date_time ? false : true"
                                                 type="border"
                                                 class="mt-3"
                                                 size="small">
                                                 {{$t('clear')}}
                                             </vs-button>
                                             <vs-button
                                                 @click="closeDateDrop()"
                                                 class="mt-3"
                                                 size="small">
                                                 {{$t('select')}}
                                             </vs-button>
                                         </div>
                                     </vs-dropdown-menu>
                                 </vs-dropdown>
                                 <flat-pickr
                                     v-else
                                     v-model="date_time"
                                     :config="mobileConfig0"/>

                                 <vs-button
                                     icon-pack="feather"
                                     class="save_btn"
                                     @click="saveHandler0()"
                                     icon="icon-save">
                                     {{$t('save')}}
                                 </vs-button>
                             </div>
                         </div>
                     </transition>

                 </transition>
            </div>

            <!-- список студентов -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl"
                @ps-y-reach-end="infiniteHandle">

                    <ul v-if="journalList.length">
                        <li
                            class="todo_todo-item cursor-pointer"
                            v-for="(item, index) in journalList"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">
                                <ListItem :item="item" :index="index" :getBlocksNone="getBlocksNone" @GetUID="GetUID"/>
                        </li>
                    </ul>

                    <!-- Выводим сообщение если данных нет -->
                    <div class="mt-4 ml-5 mr-5" v-if="emptyMessage">
                        <vs-alert active="true">
                            {{$t('no_data_text')}}
                        </vs-alert>
                    </div>

                <!-- В этот див выводил лоадер -->
                <div id="infinite_loader" class="vs-con-loading__container"></div>

                <div class="edited_dummy"></div>
            </component>
        </div>
        <vs-popup class="popup_member_add chat_cont_popup" fullscreen :title="$t('change_history')" :active.sync="popupActive">
            <ItemViewJournalHistory :uidtest="uis"/>
        </vs-popup>
    </div>
</template>

<script>
import blockJournal from '@/store/modules/block_journal.js'
import system_settings from '@/store/modules/system_settings.js'
import ListFilters from './ListFilters.vue'
import ListItem from './ListItem.vue'
import EditPopup from './EditPopup'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { Russian } from 'flatpickr/dist/l10n/ru'
import { Kazakh } from 'flatpickr/dist/l10n/kz'
import ItemViewJournalHistory from './ItemViewJournalHistory'
import { mapActions,mapGetters,mapMutations } from 'vuex'

const datePicker = {
    time_24hr: true,
    enableTime: true,
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-dTH:i:S+06:00',
}
const datePicker0 = {
    time_24hr: true,
    enableTime: true,
    minDate: new Date().setMinutes( new Date().getMinutes() + 5 ),
    altFormat: 'd.m.Y H:i',
    dateFormat: 'Y-m-dTH:i:S+06:00',
}

export default {
    data() {
        return {
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            infiniteStatus: true,
            page: 0,
            date_time: null,
            config: {
                ...datePicker,
                inline: true,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
            config0: {
                ...datePicker0,
                inline: true,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
            mobileConfig: {
                ...datePicker,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
            mobileConfig0: {
                ...datePicker0,
                // locale: this.$i18n.locale === 'kk' ? 'kz' : this.$i18n.locale
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            data_start_time:null,
            data_end_time:null,
            popupActive:false,
            uis:''
        };
    },
    components: {
        ListFilters,
        ListItem,
        flatPickr,
        VuePerfectScrollbar,
        EditPopup,
        ItemViewJournalHistory
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed: {
        ...mapGetters({
            getBlocks:'system_settings/getBlocks',
            start_date_end_date:'block_journal/start_date_end_date',
        }),
        selectedDate0() {
            if(this.date_time)
                return this.$moment(this.date_time).format('DD.MM.YYYY H:mm')
            else
                return this.$t('select_date_and_time')
        },

        selectedDate() {
            if(this.data_start_time)
                return this.$moment(this.data_start_time).format('DD.MM.YYYY H:mm')
            else
                return this.$t('date_start')
        },
        selectedDate2() {
            if(this.data_end_time)
                return this.$moment(this.data_end_time).format('DD.MM.YYYY H:mm')
            else
                return this.$t('date_end')
        },
        windowWidth() { return this.$store.state.windowWidth },
        journalList() {
            // Список журналов
            return this.$store.state.block_journal.journalList
        },
        journalEdited() {
            // Список журналов которые уже редактировали
            return this.$store.state.block_journal.journalList.filter(item => item.edited)
        },
        getBlocksNone(){
            if(this.getBlocks){
                if (this.getBlocks.length == 0){
                    return false
                }else{
                    return true
                }
            }

        }
    },
    async created() {
        // Регистрируем стор
        if(!this.$store.hasModule('block_journal'))
            this.$store.registerModule('block_journal', blockJournal)

        if(!this.$store.hasModule('system_settings'))
            this.$store.registerModule('system_settings', system_settings)

        this.setSidebarWidth()
        await this.getActionsBlocks()
    },
    beforeDestroy () {
        // Если покудаем текущий компонент, удаляем стор
        this.$store.unregisterModule('block_journal')
    },
    methods: {
        ...mapMutations({
            SET_UID_JOURNAL: 'e_journal/SET_UID_JOURNAL'
        }),
        GetUID(val){
            // console.log(val)
            this.uis = val
            if (val){
                this.$store.dispatch('e_journal/fetchJournalHistory', {id: val})
                this.SET_UID_JOURNAL(val)
            }
            this.popupActive =true
            return val

        },
        ...mapActions({
            fetchJournalList: 'block_journal/fetchJournalList',
            getActionsBlocks: 'system_settings/getBlocks',
        }),
        closeDateDrop() {
            // Закрываем попап с датой
            let [dropdownMenu] = this.$refs.dateDrop.$children.filter(item => item.hasOwnProperty('dropdownVisible'))
            dropdownMenu.dropdownVisible = false
        },
        closeDateDrop2() {
            // Закрываем попап с датой
            let [dropdownMenu] = this.$refs.dateDrop2.$children.filter(item => item.hasOwnProperty('dropdownVisible'))
            dropdownMenu.dropdownVisible = false
        },
        async saveHandler() { // Если выбран статус Открыть, используется эта функция при нажатии на Сохранить
            // Сохраняем изменения журналов
            if (this.data_start_time == null || this.data_end_time == null) {
                this.$vs.notify({
                    text: this.$t('both_dates_must_be_chosen'),
                    color: 'danger'
                })
            }else{
                try {
                    this.$vs.loading({
                        container: ".save_btn",
                        scale: 0.45
                    })

                    // Проходимся по редактируемому списку джурналов и вытаскиваем их uid
                    const journals = this.journalEdited.map(item => item.uid)

                    let queryData = { journals }

                    // Если есть дата, добавляем ее в объект
                    // if(this.data_start_time)
                    queryData['start_date'] = this.data_start_time

                    // if(this.data_end_time)
                    queryData['end_date'] = this.data_end_time


                    await this.$http.post("/admin/journal/handle/", queryData).catch(err => {
                        this.$vs.notify({
                            text: err.message_ru,
                            color: "danger",
                        });
                    });
                } catch (e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close(".save_btn > .con-vs-loading")
                    this.$store.commit('block_journal/CLEAR_JOURNAL_LIST')
                    this.date_time = null

                    // Обновляем список журналов
                    this.infiniteHandle({ update: true })
                }
            }
        },
        async saveHandler0() { // Если выбрать статус Закрыто, используется эта функция при нажатии на Сохранить
            try {
                this.$vs.loading({
                    container: ".save_btn",
                    scale: 0.45
                })

                // Проходимся по редактируемому списку джурналов и вытаскиваем их uid
                const journals = this.journalEdited.map(item => item.uid)

                let queryData = {journals}

                // Если есть дата, добавляем ее в объект
                // if(this.date_time)
                queryData['date_time'] = this.date_time

                await this.$http.post("/admin/journal_change_status/planblock/", queryData)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.$vs.loading.close(".save_btn > .con-vs-loading")
                this.$store.commit('block_journal/CLEAR_JOURNAL_LIST')
                this.date_time = null

                // Обновляем список журналов
                this.infiniteHandle({update: true})
            }

        },
        infiniteHandle({update = false}) {
            // Если update = true запрашиваем список заного с новыми параметрами
            if(update) {
                this.infiniteStatus = true
                this.page = 0
            }

            // Запрашщиваем список пользователей
            this.journalListHandler()
        },
        async journalListHandler() {
            // Запрашиваем список с выставленными параметрами
            if(!this.loading && this.infiniteStatus) {
                this.loading = true
                this.emptyMessage = false
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '#infinite_loader',
                        scale: 0.6
                    })
                })

                try {
                    this.page = this.page+1
                    const res = await this.fetchJournalList({page: this.page, route: this.$route})

                    // Если на первой странице данных нет вообще, выводим сообщение
                    if(!res || this.page === 1 && !res.results.length) this.emptyMessage = true

                    // Если запросили последнюю страницу, меняем статус инфинити скролла
                    if(!res || !res.next) this.infiniteStatus = false
                } catch({detail}) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger',
                    })
                } finally {
                    this.loading = false
                    this.$vs.loading.close('#infinite_loader > .con-vs-loading')
                }
            }
        },
        toggleSidebar (value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.edited_dummy{
    height: 53px;
}
.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}
.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
}
.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
//.vs-popup{
//    width: 100% !important;
//    height: 100% !important;
//}
.dropdown_datetime{
    .flatpickr-input{
        display: none;
    }
    .flatpickr-calendar{
        box-shadow: initial!important;
    }
}
.save_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.emc__actions{
    .con-vs-tabs{
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs{
        display: none;
    }
}
.emc_list_tabs{
    .con-ul-tabs{
        display: none;
    }
    .vs-tabs--content{
        padding: 0px;
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    height: calc(100% - 56.5px);
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.full-vs-sidebar{
    .mail-sidebar-content{
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header{
        box-shadow: 0 4px 6px rgba(0,0,0,.04);
        border-bottom: 1px solid #eee;
    }
}
@media only screen and (min-width: 901px) {
    .infinite_scroll_wrapper{
        height: 100%;
    }
}
@media only screen and (max-width: 900px) {
    .infinite_scroll_wrapper{
        height: calc(100% - 56.40px);
    }
    .save_header{
        .flex{
            justify-content: flex-end;
        }
        .vs-button{
            margin-left: 10px;
            padding: .75rem 1rem!important;
            .vs-button--text{
                display: none;
            }
        }
        .flatpickr-input{
            width: 100%;
            max-width: 160px;
        }
    }
    .infinite_header{
        min-height: 56.40px;
    }
}
</style>
